import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BillLimitsComponent } from './bill-limits.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { PermissionsGuardService } from 'src/app/shared/services/permissions-guard.service';
import { AuthGuardService } from 'src/app/shared/services/auth.guard';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
/* import { SelectDropDownModule } from 'ngx-select-dropdown'; */

const billLimitsRoutes = [
  {
    path: '',
    component: BillLimitsComponent,
    canActivate: [PermissionsGuardService, AuthGuardService],
  },
];

@NgModule({
  declarations: [BillLimitsComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(billLimitsRoutes),
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    /* SelectDropDownModule, */
  ],
})
export class BillLimitsModule {}
